"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBucketVersioningOutput = {
    type: "structure",
    required: [],
    members: {
        Status: {
            shape: {
                type: "string"
            }
        },
        MFADelete: {
            shape: {
                type: "string"
            },
            locationName: "MfaDelete"
        }
    }
};
//# sourceMappingURL=GetBucketVersioningOutput.js.map